export default __webpack_public_path__ + "static/media/mic.4ad5b6cd.svg";